module.exports = require('./helpers/bundle-url').getBundleURL('cuAka') + "logo.7718c6df.svg";